<doc>
  @desc:   布局 - 热门赛事组件
  @author:  
</doc>
<template>
  <div class="hot-league-wrapper" v-if="hotNum != hotLeagues.length">
    <div class="league-title flex flex-align-center">
      <i class="league-title-icon icon-font icon-hot"></i>
      <h3 class="league-title-text">{{ langConfig.txtLang[langConfig.curLang]['TOP_LEAGUES'] }}</h3>
    </div>
    <div class="league-item">
      <ul class="league-list" v-for="(item, key) in hotLeagues">
        <li class="flex flex-align-center" :key="key" v-if="typeof(item.show) == 'undefined' || item.show">
          <img class="country-flag" :src="common.noCountryBack(item, 'img')" @error="common.imgError($event, 'country')" />
          <span @click="toLeague(item)"><router-link :to="toLeague(item)" :class="toCss(item)">{{ item['fullName'] }}</router-link></span>
        </li>
        <!-- <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li>
        <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li>
        <li class="flex flex-align-center">
          <img class="country-flag" src="~@/assets/images/flag.png" />
          <span><router-link to="">English Premier League</router-link></span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
  //import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    props: {
      hotLeague: {
        type: Array,
        default: () => [],
      },
      myLeague: {
        type: Array,
        default: () => [],
      }
    },
    data(){
      return{
        hotLeagues: [],
        hotNum:0,
      }
    },
    computed: {
      //...mapState('home', ['hotLeague']),
    },
    mounted(){
      // this.getHotLeagueData();
      // this.$watch('myLeague', (val) => {
      //   this.getHotLeagueData(val);
      // });
    },
    methods: {
      //...mapMutations('home', ['setHotLeague']),

      getHotLeagueData(val){
        let _hotLeague = [], _myLeague = [], _num = 0;

        if(typeof(this.myLeague) != 'undefined'){
          _myLeague = this.myLeague;
        }
        if(typeof(this.hotLeague) != 'undefined'){
          _hotLeague = this.common.jsonParse(this.hotLeague);
        }

        if(_hotLeague.length > 0 && _myLeague.length > 0){
          for(let i=0; i<_hotLeague.length; i++){
            let _hotId = _hotLeague[i]['id'];
            for(let j=0; j<_myLeague.length; j++){
              let _myId = _myLeague[j]['id'];
              if(typeof(_hotLeague[i].show) == 'undefined'){
                _hotLeague[i].show = true;
              }
              if((_hotId == _myId) && _hotLeague[i].show){
                _num++;
                _hotLeague[i].show = false;
                break;
              }
            }
          }
        }

        this.hotNum = _num;
        this.hotLeagues = _hotLeague;
      },
      // 跳转联赛
      toLeague(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];
        
        if(typeof(_hasDt) != 'undefined' && _hasDt){
          return '/leagues/' + _leagueId + '/0';
          //this.$router.push('/leagues/' + _leagueId + '/0');
        }else{
          return ''
        }
      },

      //样式
      toCss(val){
        let _leagueId = val.id, _hasDt = val['hasDt'];

        if(typeof(_leagueId) != 'undefined' && _hasDt){
          return '';
        }

        return 'league-title-hover';
      }
    },

    created(){
      
    },
    watch: {
      hotLeague: {
        immediate: true,
        handler(val) {
          if(this.hotLeagues != val){
            this.getHotLeagueData();
          }
        }
      },
      myLeague: {
        immediate: true,
        handler(val) {
          if(this.hotLeagues != val){
            this.getHotLeagueData();
          }
        }
      }
    }
  }
</script>

<style lang="less">
.hot-league-wrapper{
  padding:20px 0;
  margin:0 16px;
  border-bottom:1px solid @color_D9D9D9;
  .league-title-icon{
    color:@color_E8503A;
    font-size:22px;
    margin-right:6px;
  }
  .league-title-text{
    color:#000;
    font-size:16px;
    font-weight:600;
    font-family: @font_family_SF_Pro_Display;
  }
  .league-list{
    li{
      margin-top:16px;
      img{
        width:18px;
        margin-right:8px;
      }
      span{
        color:@color_434343;
        font-size:14px;
        font-family: @font_family_SF_Pro_Display;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-clamp: 1;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        a{
          color:@color_434343;
          &:hover{
            text-decoration: underline;
          }
        }
      }
      .league-title-hover{
        cursor: default;
        &:hover{
          text-decoration: none;
        }
      }
    }
  }
}
/* phone */
@media screen and (max-width: 767px) {
  .hot-league-wrapper{
    padding:.2rem 0;
    margin:0 .16rem;
    border-bottom:0;
    .league-title-icon{
      font-size:.22rem;
      margin-right:.06rem;
    }
    .league-title-text{
      font-size:.16rem;
    }
    .league-list{
      li{
        margin-top:.16rem;
        img{
          width:.18rem;
          margin-right:.08rem;
        }
        span{
          font-size:.14rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/hotLeague.vue